module.exports = __webpack_public_path__ + "static/img/ent-42.076af48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-42.jpg
// module id = cDfy
// module chunks = 51